import React from 'react';
import { t } from 'ttag';
import { Button } from '~/ui/buttons/Button';
import { Flex } from '~/ui/flex/Flex';
import DOMPurify from 'dompurify';
import ClockIcon from '../assets/clock.svg';
import { OnboardingStages, useOnboardingStore } from '../Store';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';
import { useNextSequence } from '~/training/useNextSequence';
import { formatDurationInMinutes } from '~/lib/formatters/duration';

const selector = (s: TrainingState) =>
  select(
    s,
    'disclaimer',
    'onboarding',
    'scorePassingPercent',
    'duration',
    'title',
    'regionName'
  );

export const CourseDuration = () => {
  const { stage, goTo } = useOnboardingStore();

  const {
    disclaimer,
    onboarding,
    scorePassingPercent,
    duration,
    title: unsanitizedTitle,
    regionName: unsanitizedRegionName
  } = useTrainingStore(selector);

  const nextSequence = useNextSequence();

  const GoNext = () => {
    if (disclaimer) {
      return goTo(OnboardingStages.Disclaimer);
    } else if (scorePassingPercent && scorePassingPercent > 0) {
      return goTo(OnboardingStages.PassFail);
    } else if (onboarding) {
      return goTo(OnboardingStages.Autosaving);
    } else {
      nextSequence().then();
    }
  };

  const regionName = DOMPurify.sanitize(unsanitizedRegionName || '', {
    USE_PROFILES: { html: true }
  });
  const title = DOMPurify.sanitize(unsanitizedTitle || '', {
    USE_PROFILES: { html: true }
  });
  const formattedDuration = formatDurationInMinutes(duration);

  return (
    <Flex
      variant="list"
      justifyContent="space-between"
      data-test-id="course-duration-card"
    >
      <h2>{t`Course Duration`}</h2>
      <Flex variant="center" w="auto" h="auto">
        <ClockIcon />
      </Flex>
      <small
        dangerouslySetInnerHTML={{
          __html: t`<b>${regionName}</b> law requires you to complete at least <b>${formattedDuration}</b> of ${title}.`
        }}
      />
      <Button
        onClick={GoNext}
        disabled={stage !== OnboardingStages.CourseDuration}
        aria-hidden={stage !== OnboardingStages.CourseDuration}
        data-test-id="next-button"
      >
        {t`Next`}
      </Button>
    </Flex>
  );
};
